import { ConfigurationSectionOperationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section-operation/configuration-section-operation.dto'
import { OperationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/operation/operation.dto'
import { CommonPortionTypeResponse } from '@/api/services/common/portion-type/common-portion-type.dto'
import { CommonSubportionTypeResponse } from '@/api/services/common/subportion-type/common-subportion-type.dto'
import { Nullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface ConfigurationLocalAssaysSectionsModalOperationsFormState {
    sectionOperations: ConfigurationSectionOperationResponse[]
    operation: Nullable<OperationResponse>
    portionType: Nullable<CommonPortionTypeResponse>
    subportionType: Nullable<CommonSubportionTypeResponse>
    laboratoryId: number
}
export const initialConfigurationLocalAssaysSectionsModalOperationsFormState =
    (): ConfigurationLocalAssaysSectionsModalOperationsFormState => ({
        sectionOperations: [],
        operation: null,
        portionType: null,
        subportionType: null,
        laboratoryId: store.getters.labId
    })
